var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColor = function SvgColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "color_svg__st0",
    d: "M8.53 7.12A5.95 5.95 0 0 1 11 6.1V.06C8.44.27 6.11 1.28 4.26 2.85l4.27 4.27zM6.09 11c.15-.91.51-1.75 1.02-2.47L2.84 4.26A11.891 11.891 0 0 0 .05 11h6.04zM13 .05v6.04c.91.15 1.75.51 2.47 1.02l4.27-4.27A11.891 11.891 0 0 0 13 .05zM7.11 15.47A5.95 5.95 0 0 1 6.09 13H.05c.21 2.56 1.22 4.89 2.79 6.74l4.27-4.27zM17.91 13a5.95 5.95 0 0 1-1.02 2.47l4.27 4.27c1.57-1.85 2.58-4.18 2.79-6.74h-6.04zM11 17.91a5.95 5.95 0 0 1-2.47-1.02l-4.27 4.27c1.85 1.57 4.18 2.58 6.74 2.79v-6.04zM16.89 8.53c.51.72.87 1.56 1.02 2.47h6.04c-.21-2.56-1.22-4.89-2.79-6.74l-4.27 4.27zM15.47 16.89c-.72.51-1.56.87-2.47 1.02v6.04c2.56-.21 4.89-1.22 6.74-2.79l-4.27-4.27z"
  })));
};
export default SvgColor;